import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AngularFirestoreCollection, AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  usersCollectionRef: AngularFirestoreCollection<any>;
  constructor(private angularFirestore: AngularFirestore, private httpClient: HttpClient) {
    this.usersCollectionRef = this.angularFirestore.collection('users');
  }

  addUser(data) {
    return this.httpClient.post(`${environment.apiUrl}/addUser`, data);
  }

  create(uuid, data) {
    // console.log(user)assets/img/portrait/avatars/avatar-08.png
    // if (!data.photoURL) {
    //   if (data.gender === 'F') {
    //   }
    //   if (data.gender === 'M') {
    //     data.photoURL = 'assets/img/portrait/avatars/avatar-08.png';
    //   }
    //   if (data.gender === 'Other') {
    //   }
    // }
    return this.usersCollectionRef.doc(uuid).set(data);
    // .then(() => {
    //   // alert('success');
    //   console.log('new user');
    // })
    // .catch(err => {
    //   // alert(err.message);
    // });
  }

  get(id) {
    return this.usersCollectionRef.doc(id).valueChanges();
  }

  getOne(id) {
    return this.usersCollectionRef.doc(id).ref.get();
  }

  update(id: string, data) {
    return this.usersCollectionRef.doc(id).update(data);
  }

  checkIfMatchingPasswords(passwordKey: string, passwordConfirmationKey: string) {
    return (group: FormGroup) => {
      const passwordInput = group.controls[passwordKey],
        passwordConfirmationInput = group.controls[passwordConfirmationKey];
      if (passwordInput.value !== passwordConfirmationInput.value) {
        return passwordConfirmationInput.setErrors({ notEquivalent: true });
      } else {
        return passwordConfirmationInput.setErrors(null);
      }
    };
  }
}
